<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }} - Départ 9h30</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>

          <p>
            La Ronde la Touloubre a été créée en 1990 par l’association Les Relayeurs de Grans. Cette année, elle se déroulera le dimanche 26 novembre. Les épreuves de Grans ont souvent été primées par la Commission Départementale Running 13 (CDR13),
            6 fois premières et toujours dans le top 10 des meilleures courses régionales. Leur notoriété repose sur le sérieux de leurs organisations, le cadre bucolique de leurs parcours et leur ambiance conviviale.
            <br />
            Chaque année, de 300 à 400 coureurs s’y retrouvent pour fouler les sentiers et chemins gransois.<br />

            A l’arrivée tout le monde est récompensé d’une bouteille d’huile d’olive made in Grans. Côté podiums, les vainqueurs de chaque catégorie reçoivent un panier garni de produits locaux sans oublier notre huile d’olive de la maison LEYDIER.
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/touloubre_photo.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : Pierre Berud 06 21 65 43 20 : Mail : beru.pierre@neuf.fr</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/REGLEMENT_RONDE_DE_LA_TOULOUBRE_20232.jpg" target="_blank">Réglement</b-button>
          <b-button class="infos_btn" href="https://www.courirenfrance.com/" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>